/**
 * Resolve display name from entity with name_hu, name_sk, name_en columns.
 * Used for pipelines, stages, and other translated lookup values.
 */
export type Lang = 'hu' | 'sk' | 'en';

export interface TranslatedNameRow {
  name?: string | null;
  name_hu?: string | null;
  name_sk?: string | null;
  name_en?: string | null;
}

export function getTranslatedName(
  row: TranslatedNameRow | null | undefined,
  lang: Lang
): string {
  if (!row) return '';
  if (lang === 'hu' && (row.name_hu != null && row.name_hu !== '')) return row.name_hu;
  if (lang === 'sk' && (row.name_sk != null && row.name_sk !== '')) return row.name_sk;
  if (lang === 'en' && (row.name_en != null && row.name_en !== '')) return row.name_en;
  return (row.name_hu ?? row.name_sk ?? row.name_en ?? row.name ?? '') as string;
}

export function getCurrentLang(i18nLanguage: string): Lang {
  return i18nLanguage === 'sk' ? 'sk' : i18nLanguage === 'en' ? 'en' : 'hu';
}
